
import { mixins, Options } from 'vue-class-component';
import { BaseWidgets, DataWidgetName, isRecognisedWidgetName } from '@/exported';
import { MCampaignWidgetPropProvider } from './MCampaignWidgetProps';
import MCampaign from './widget/MCampaign.vue';
import MCountdown from './widget/MCountdown.vue';
import MTokenChecker from './widget/MTokenChecker.vue';

@Options({
  components: {
    MCampaign,
    MCountdown,
    MTokenChecker
  }
})
export default class MCampaignWrapper extends mixins(MCampaignWidgetPropProvider) {
  parentDataWidgetName: DataWidgetName | null = null;
  mounted(): void {
    const widgetName = this.$el?.parentElement?.getAttribute('data-widget') || '';
    if (!widgetName || !isRecognisedWidgetName(widgetName)) {
      this.parentDataWidgetName = null;
    }
    this.parentDataWidgetName = widgetName;
  }

  get dynamicComponent() {
    if (!this.parentDataWidgetName || !BaseWidgets[this.parentDataWidgetName]) {
      return null;
    }
    return BaseWidgets[this.parentDataWidgetName].component;
  }
}
